// @ts-strict-ignore
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { Mesh } from 'three';
import { ProjectModel } from '@project/model/project.model';
import { TextureElementVO } from '@article/model/vo/texture-element.vo';
import { IOperation } from '@shared/undo/operation/i-operation';
import { MeshUtils } from '@3d-scene/common/util/mesh-utils';
import { SelectionModelService } from '@project/components/article/service/selection-model.service';
import { SceneManager } from '@3d-scene/manager/scene.manager';
import { ApplicationRefreshService } from '@services/application-refresh.service';

export class UndoTextureElementOperation implements IOperation {

  private _articleContainer: ArticleContainer;
  private _oldMeshes: Mesh[];
  private _newMeshes: Mesh[];
  private _oldTextureElements: TextureElementVO[];
  private _newTextureElements: TextureElementVO[];
  private _operationDescription: string;

  public constructor(private projectModel: ProjectModel,
                     private selectionModelService: SelectionModelService,
                     private sceneManager: SceneManager,
                     private applicationRefreshService: ApplicationRefreshService,
                     articleContainer: ArticleContainer,
                     oldMeshes: Mesh[],
                     newMeshes: Mesh[],
                     oldTextureElements: TextureElementVO[],
                     newTextureElements: TextureElementVO[],
                     operationDescription: string) {
    this._articleContainer = articleContainer;
    this._oldMeshes = oldMeshes;
    this._newMeshes = newMeshes;
    this._oldTextureElements = oldTextureElements;
    this._newTextureElements = newTextureElements;
    this._operationDescription = operationDescription;
  }

  public getQualifiedClassName(): string {
    return 'UndoTextureOperation';
  }

  public getOperationDescription(): string {
    return this._operationDescription;
  }

  public performUndo(): Promise<void> {
    return this.changeTexture(this._newMeshes, this._oldMeshes, this._oldTextureElements);
  }

  public performRedo(): Promise<void> {
    return this.changeTexture(this._oldMeshes, this._newMeshes, this._newTextureElements);
  }

  private async changeTexture(meshesToRemove: Mesh[], meshesToAdd: Mesh[], textureElements: TextureElementVO[]): Promise<void> {
    meshesToRemove.forEach((mesh: Mesh) => {
      const meshToRemove = this._articleContainer.model.getObjectByName(mesh.name);
      if (meshToRemove) {
        this._articleContainer.model.remove(meshToRemove);
      }
    });
    const clonedMeshesToAdd: Mesh[] = meshesToAdd.map((mesh: Mesh) => MeshUtils.cloneMesh(mesh));
    this._articleContainer.model.add(...clonedMeshesToAdd);
    this._articleContainer.article.textureElements = textureElements.concat();

    await this.applicationRefreshService.refreshProject();
    this.projectModel.notifyCurrentProjectChanged();
    this.selectionModelService.removeAllSelections();
    this.sceneManager.renderScene();
    this.applicationRefreshService.notifyProjectChange();
  }
}
